import { Iso3166Region } from "../Types";

export enum ConsentManagementVariant {
  NONE = "NONE",
  INFORMATIONAL_ONLY = "INFORMATIONAL_ONLY",
  INTERACTIVE_DEFAULT_CONSENT = "INTERACTIVE_DEFAULT_CONSENT",
  INTERACTIVE_DEFAULT_NO_CONSENT = "INTERACTIVE_DEFAULT_NO_CONSENT",
}

export interface CustomConsentManagementVariant {
  variant: ConsentManagementVariant;
  region: Iso3166Region; // ISO-3166-2 e.g. "US-CA"
}

export enum ConsentBannerScreenPosition {
  BOTTOM_LEFT = "BOTTOM_LEFT",
  BOTTOM_CENTER = "BOTTOM_CENTER",
  BOTTOM_RIGHT = "BOTTOM_RIGHT",
  MIDDLE_CENTER = "MIDDLE_CENTER",
}

export enum ConsentRequiredMode {
  NONE = "NONE",
  EVERYWHERE = "EVERYWHERE",
}

export enum InformationalBannerDismissalStyle {
  ACCEPT_BUTTON = "ACCEPT_BUTTON",
  ACCEPT_AND_X_BUTTON = "ACCEPT_AND_X_BUTTON",
}

export enum ConsentBannerUSVisibility {
  ALL = "ALL",
  USP_ONLY = "USP_ONLY",
  CA_ONLY = "CA_ONLY",
}

export enum BannerCopyVariant {
  DEFAULT = "DEFAULT",
  CUSTOMIZE_STRICTLY_NECESSARY_ACCEPT_ALL = "CUSTOMIZE_STRICTLY_NECESSARY_ACCEPT_ALL",
}

/**
 * Data Transfer Object defining the transport of Consent Management Platform (CMP) settings.
 */
export interface CMPSettingsDto {
  usConsentManagementVariant?: ConsentManagementVariant; // Legacy - will be deleted in favor of:
  usConsentManagementVariantCA?: ConsentManagementVariant;
  usConsentManagementVariantUSP?: ConsentManagementVariant;
  usConsentManagementVariantNonUSP?: ConsentManagementVariant;
  usConsentManagementVariantMinors?: ConsentManagementVariant;
  eeaukConsentManagementVariant?: ConsentManagementVariant;
  canadaConsentManagementVariant?: ConsentManagementVariant;
  customConsentManagementVariants?: CustomConsentManagementVariant[];

  informationalBannerTitle: string;
  informationalBannerText: string;
  informationalBannerAcceptButtonText: string;
  informationalBannerDismissalStyle?: InformationalBannerDismissalStyle;
  bannerTextOptInEn: string;
  bannerTextOptOutEn: string;
  bannerCopyVariant?: BannerCopyVariant;

  usBannerVisibility: ConsentBannerUSVisibility; // Legacy - will be deleted after POL-4957

  bannerBackgroundColor?: string;
  bannerIconColorPrimary?: string;
  bannerIconColorSecondary?: string;

  bannerScreenPosition?: ConsentBannerScreenPosition;

  previewForceGeoCountry?: string;
  previewForceGeoRegion?: string;
  previewURL?: string;

  consentRequiredMode?: ConsentRequiredMode;
  allowCSSOverrides?: boolean;

  isStagingPublish?: boolean;

  // Info about the organization (backend->frontend only, not stored as configuration)
  orgInfo?: CMPSettingsOrgInfoDto;

  // Legacy fields
  informationalConsentManagementVariant: boolean; // Can be a boolean while the simple checkbox is in place; for dropdown, remove boolean option and use Enum above. Currently remapped at the API boundary for the checkbox era.
  gdprConsentManagementEnabled: boolean;
}

export interface CMPSettingsOrgInfoDto {
  showMinorsConsentSettingsUnder18?: boolean;
  showMinorsConsentSettingsUnder16?: boolean;
  isSellingOrSharing?: boolean;
  acceptsVoluntaryRequests?: boolean;
}
